module.exports = __webpack_public_path__ + "img/43-config-cadastros-restritos-lista.1c82aea1.png";